// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 869 ? "toolpath3d" : chunkId) + "." + {"408":"020b1afc","869":"99868e4d"}[chunkId] + ".chunk.js";
};